import { Stack, Typography } from '@mui/material';
import { useState } from 'react';

import { VegaCard, VegaTable } from '../../../../components/common';
import VegaContainedButton from '../../../../components/common/VegaContainedButton';
import VegaDrawer from '../../../../components/common/VegaDrawer';
import VegaLabel from '../../../../components/common/VegaLabel';
import { getLogoForNetwork } from '../../../../components/icon/Icons';
import { toLowerCase } from '../../../../constants/commonFunction';
import { useClientAuth } from '../../../../providers/ClientProvider';
import { useSnackbar } from '../../../../providers/SnackbarProvider';
import { CHECKER_MAKER_STATUS } from '../../../types/Commons';
import { ISectionProps } from '../../pages/MCCUserManagement';
import IssueDetails from './Components/IssueDetails';
import KitDretails from './Components/KitDretails';
import PersonalisedDetails from './Components/PersonalisedDetails';

interface IProps {
  active: ISectionProps;
  data: any;
  loading?: boolean;
  isMapCardShow: boolean;
  hide?: boolean;
  onCreate: (data: any) => void;
  onGenerateOTP: (data: any) => void;
  onCheckerStatus: (data: any) => void;
  onAllocateCard: (data: any) => void;
  onUpdateCheckerStatus: (data: any, status?: CHECKER_MAKER_STATUS) => void;
}

export const checkNullValue = (value: any) => {
  if (value !== null || value !== undefined) {
    return value;
  } else return false;
};

const ListOfCardSaleMaker = ({
  active,
  data,
  loading,
  isMapCardShow,
  hide,
  onCreate,
  onGenerateOTP,
  onCheckerStatus,

  onAllocateCard,
  onUpdateCheckerStatus,
}: IProps) => {
  const { userId, mccPlatformId: branchId } = useClientAuth();
  const [open, setOpen] = useState<boolean>(false);
  const getBinId: any = sessionStorage.getItem('binId');
  const [checkValue, setCheckValue] = useState<string>('');
  const [showData, setShowData] = useState<any>({});
  const { setSnackbar } = useSnackbar();

  const getButtons = (
    status: string,
    checkerMakerStatus: string,
    data: any,
    isCard?: boolean
  ) => {
    // return <VegaContainedButton text={checkerMakerStatus} isPrimary />;

    if (status === 'DRAFT') {
      return (
        <VegaContainedButton
          text="Send to Checker"
          onClick={() => onCheckerStatus(data)}
          isPrimary
        />
      );
    }
    if (
      status === 'UNDER_REVIEW' &&
      checkerMakerStatus === CHECKER_MAKER_STATUS.REVIEWER_PENDING
    ) {
      return (
        <VegaContainedButton
          text="Send to Checker"
          onClick={() =>
            onUpdateCheckerStatus(data, CHECKER_MAKER_STATUS.CHECKER_PENDING)
          } // updateChecker
          isPrimary
        />
      );
    }

    if (status === 'ACTIVE' && checkerMakerStatus === 'APPROVED' && isCard) {
      return (
        // <ButtonGroup
        //   variant="contained"
        //   aria-label="outlined primary button group"
        // >
        //   <VegaContainedButton
        //     isLeftBorder
        //     px={1}
        //     mx="0"
        //     text="OTP"
        //     onClick={() => showDetails(data, 'GENERATE_OTP')}
        //     isPrimary
        //     disabled={hide}
        //   />
        //   <VegaContainedButton
        //     isRightBorder
        //     px={1}
        //     mx="0"
        //     text="Map Card"
        //     onClick={() => showDetails(data, 'MAP_CARD')}
        //     isPrimary
        //     disabled={getShow(showData.id !== data.id, isMapCardShow)}
        //   />
        // </ButtonGroup>
        <VegaContainedButton
          text="Map Card"
          onClick={() => showDetails(data, 'MAP_CARD')}
          isPrimary
          // disabled={getShow(showData.id !== data.id, isMapCardShow)}
        />
        // <VegaContainedButton
        //   text="Genrate OTP"
        //   onClick={() => showDetails(data, 'GENERATE_OTP')}
        //   isPrimary
        //   disabled={hide}
        // />
      );
    }
    if (status === 'INACTIVE') {
      return <VegaContainedButton text="Inactive" isPrimary disabled />;
    }
    if (
      status === 'UNDER_REVIEW' &&
      checkerMakerStatus === 'CHANGES_REQUESTED'
    ) {
      return (
        <VegaContainedButton
          text="Send to Checker"
          // onClick={() => showDetails(data, 'EDIT')} // updateChecker
          onClick={() => onUpdateCheckerStatus(data)} // updateChecker
          isPrimary
        />
      );
    }
    if (status === 'UNDER_REVIEW' && checkerMakerStatus === 'CHECKER_PENDING') {
      return (
        <VegaContainedButton
          text="Sent to Checker"
          //  onClick={() => onCheckerStatus(data)} // updateChecker
          isPrimary
          disabled
        />
      );
    }
  };

  const getShow = (isMatchId: boolean, flag: boolean) => {
    if (flag) {
      if (isMatchId && flag) {
        return true;
      } else return false;
    } else return true;
  };

  const KIT_COLUMN = [
    {
      field: 'customerId',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          Customer Name
        </Typography>
      ),
      flex: 1,
      renderCell: (props: any) => {
        return (
          <Typography>
            {checkNullValue(props.row.customer?.firstName)}
          </Typography>
        );
      },
    },
    {
      field: 'cardNo',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          Card No
        </Typography>
      ),
      flex: 1,
      renderCell: (props: any) => {
        return (
          <VegaLabel
            text={props?.row?.card?.cardNumber ?? '--'}
            color="primary"
          />
        );
      },
    },

    // {
    //   field: 'expiryDate',
    //   headerName: <Typography className="font-aspekta-500" variant="body2">Card Expiry</Typography>,
    //   flex: 0.5,
    //   renderCell: (props: any) => {
    //     return (
    //       <VegaLabel
    //         text={props?.row?.card?.expiryDate ?? ''}
    //         color="primary"
    //       />
    //     );
    //   },
    // },

    {
      field: 'emaiId',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          Email Id
        </Typography>
      ),
      flex: 1,
      renderCell: (props: any) => {
        return (
          <Typography>{checkNullValue(props.row.customer?.emailId)}</Typography>
        );
      },
    },
    {
      field: 'mobileNumber',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          Mobile No.
        </Typography>
      ),
      flex: 1,
      renderCell: (props: any) => {
        return (
          <Typography>
            {checkNullValue(props.row.customer?.mobileNumber)}
          </Typography>
        );
      },
    },

    {
      field: 'cardNetwork',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          Card Network
        </Typography>
      ),
      flex: 0.5,
      renderCell: (props: any) => {
        const networks = props.row.card?.cardNetwork;
        if (!networks || networks.length <= 0) {
          return;
        }
        return (
          <Stack direction={'row'} alignItems="center" spacing={2}>
            <div>{getLogoForNetwork(networks)}</div>
          </Stack>
        );
      },
    },

    {
      field: 'Request',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          {' '}
          Action
        </Typography>
      ),
      flex: 1,
      renderCell: (props: any) => {
        const accountData = props.row.account;
        const cardData = props.row.card;
        return checkNullValue(accountData) ? (
          checkNullValue(cardData) ? (
            <VegaContainedButton
              text="View"
              onClick={() => showDetails(props.row, 'VIEW')}
              isPrimary
            />
          ) : (
            getButtons(
              props.row.account?.status,
              props.row.account?.checkerMakerStatus,
              accountData,
              !checkNullValue(cardData)
            )
          )
        ) : (
          <VegaContainedButton
            text="Create Account"
            onClick={() => showDetails(props.row, 'CREATE_ACCOUNT')}
            isPrimary
          />
        );
      },
    },
    // {
    //   field: 'Action',
    //   headerName: <Typography className="font-aspekta-500" variant="body2"> Action</Typography>,
    //   flex: 0.7,
    //   renderCell: (props: any) => {
    //     const accountData = props.row.account;
    //     const cardData = props.row.card;

    //     return (
    //       checkNullValue(accountData) &&
    //       checkNullValue(accountData).status === 'ACTIVE' &&
    //       checkNullValue(accountData).checkerMakerStatus === 'APPROVED' &&
    //       !checkNullValue(cardData) && (
    //         <VegaContainedButton
    //           text="Map Card"
    //           onClick={() => showDetails(props.row, 'MAP_CARD')}
    //           isPrimary
    //           disabled={getShow(showData.id !== accountData.id, isMapCardShow)}
    //         />
    //       )
    //     );
    //   },
    // },
  ];
  const PERSONALISED_COLUMN = [
    {
      field: 'name',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          Name
        </Typography>
      ),
      flex: 1,
    },
    {
      field: 'programName',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          Program Name
        </Typography>
      ),
      flex: 1,
    },
    {
      field: 'customerId',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          Customer ID
        </Typography>
      ),
      flex: 1,
    },
    {
      field: 'cardNo',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          Card No
        </Typography>
      ),
      flex: 1,
    },
    {
      field: 'expiryDate',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          {' '}
          Expiry Date
        </Typography>
      ),
      flex: 0.5,
    },
    {
      field: 'activationDate',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          {' '}
          Activation Date
        </Typography>
      ),
      flex: 0.5,
    },

    {
      field: 'status',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          {' '}
          Status
        </Typography>
      ),
      flex: 0.7,
      renderCell: (props: any) => {
        return props.row.status === 'APPROVED' ? (
          <VegaContainedButton
            text="Approved"
            // onClick={() => showBalance(props.row)}
            isSuccess
            disabled
          />
        ) : props.row.status === 'REJECTED' ? (
          <VegaContainedButton
            text="Rejected"
            // onClick={() => showBalance(props.row)}
            isDanger
            px={2.5}
            disabled
          />
        ) : (
          <VegaContainedButton
            text="Pending"
            // onClick={() => showBalance(props.row)}
            isWarning
            px={2.7}
            disabled
          />
        );
      },
    },
    {
      field: 'details',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          {' '}
          Details
        </Typography>
      ),
      flex: 0.7,
      renderCell: (props: any) => {
        return (
          <VegaContainedButton
            text="View"
            onClick={() => showDetails(props.row, '')}
            isPrimary
          />
        );
      },
    },
  ];

  const REISSUE_COLUMN = [
    {
      field: 'kitNo',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          Kit No
        </Typography>
      ),
      flex: 1,
    },
    {
      field: 'name',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          Name
        </Typography>
      ),
      flex: 1,
    },
    {
      field: 'programName',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          Program Name
        </Typography>
      ),
      flex: 1,
    },
    {
      field: 'customerId',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          Customer ID
        </Typography>
      ),
      flex: 1,
    },
    {
      field: 'cardNo',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          Card No
        </Typography>
      ),
      flex: 1,
    },
    {
      field: 'expiryDate',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          {' '}
          Expiry Date
        </Typography>
      ),
      flex: 0.5,
    },
    {
      field: 'activationDate',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          {' '}
          Activation Date
        </Typography>
      ),
      flex: 0.5,
    },

    {
      field: 'status',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          {' '}
          Status
        </Typography>
      ),
      flex: 1,
      renderCell: (props: any) => {
        return props.row.status === 'APPROVED' ? (
          <VegaContainedButton
            text="Approved"
            // onClick={() => showBalance(props.row)}
            isSuccess
            disabled
          />
        ) : props.row.status === 'REJECTED' ? (
          <VegaContainedButton
            text="Rejected"
            // onClick={() => showBalance(props.row)}
            isDanger
            px={2.5}
            disabled
          />
        ) : (
          <VegaContainedButton
            text="Pending"
            // onClick={() => showBalance(props.row)}
            isWarning
            px={2.7}
            disabled
          />
        );
      },
    },
    {
      field: 'details',
      headerName: (
        <Typography className="font-aspekta-500" variant="body2">
          {' '}
          Details
        </Typography>
      ),
      flex: 1,
      renderCell: (props: any) => {
        return (
          <VegaContainedButton
            text="Issue New"
            onClick={() => showDetails(props.row, '')}
            isPrimary
          />
        );
      },
    },
  ];

  const showDetails = (data: any, value: string) => {
    const newObj = { ...data, binId: getBinId ? parseInt(getBinId) : '' };
    setCheckValue(value);
    setOpen(!open);
    setShowData(newObj);
  };

  const onClose = () => {
    setOpen(!open);
  };

  const onSubmit = () => {};
  const createAccount = async () => {
    if (checkValue === 'CREATE_ACCOUNT') {
      await onCreate(showData);
      onClose();
    } else if (checkValue === 'GENERATE_OTP') {
      await onGenerateOTP(showData);
    } else if (checkValue === 'MAP_CARD') {
      if (isMapCardShow) {
        await onAllocateCard(showData);
        onClose();
      } else {
        await onGenerateOTP(showData);
      }
    }
  };
  const onChange = (name: string, value: any) => {
    if (name === 'binId') {
      sessionStorage.setItem('binId', value);
    }
    setShowData({ ...showData, [name]: value });
  };

  const getValue = (id: string) => {
    if (id === 'PERSONALISED_SALE') {
      return {
        column: PERSONALISED_COLUMN,
        header: 'Card Details',
        component: (
          <PersonalisedDetails state={showData} handleChange={onChange} />
        ),
        onSubmit,
        submitText: 'Submit',
      };
    } else if (id === 'REISSUE') {
      return {
        column: REISSUE_COLUMN,
        header: 'Wallet Details',
        component: <IssueDetails state={showData} handleChange={onChange} />,
        onSubmit,
        submitText: 'Submit',
      };
    } else {
      return {
        column: KIT_COLUMN,
        header: toLowerCase(checkValue),
        component: (
          <KitDretails
            state={showData}
            handleChange={onChange}
            checkValue={checkValue}
            isMapCardShow={isMapCardShow}
          />
        ),
        onSubmit: createAccount,
        submitText:
          !isMapCardShow && checkValue !== 'CREATE_ACCOUNT'
            ? 'Generate OTP'
            : 'Submit',
      };
    }
  };

  return (
    <VegaCard fullHeight noPad>
      <VegaTable
        data={data}
        columnDef={getValue(active.id).column}
        idColumn={'id'}
        loading={loading}
      />
      <VegaDrawer
        open={open}
        isClose
        isSubmit={checkValue !== 'VIEW'}
        header={getValue(active.id).header}
        closeText={checkValue === 'VIEW' ? 'Got it!' : 'Cancel'}
        submitText={getValue(active.id).submitText}
        onClose={onClose}
        onSubmit={getValue(active.id).onSubmit}
      >
        {getValue(active.id).component}
      </VegaDrawer>
    </VegaCard>
  );
};

export default ListOfCardSaleMaker;
